// =====================================================================
// Clean event detector (§9)
// =====================================================================
// 仕様準拠: closing_river_v9_spec.md §9
//
// Clean event 定義 (1手の操作で):
//   1. 操作辺 e=(u,v) が消費される (=history 移動)、value(u) == value(v) で合流
//   2. 合流後、§3 ステップ4 で self_loop として history へ移動する辺が
//      1本以上存在する
//
// 実装方針:
//   operation.ts の applyOperation が ApplyResult.cleanEvent / selfLoopEdgeIds
//   を返すので、本ファイルでは:
//     - シーケンス (履歴 history_edges) から Clean event を後追い検出する
//     - 1勝利エピソード内で Clean event 回数を集計する
// =====================================================================
/** ApplyResult シーケンスから Clean event ログを構築 */
export function buildCleanEventLog(results) {
    const perStep = results.map((r) => r.cleanEvent);
    const totalCount = perStep.filter(Boolean).length;
    return { perStep, totalCount };
}
/**
 * history_edges から Clean event を後追い検出する。
 * - 各 step で deleted_reason == "self_loop" の history_edge が
 *   1本以上存在し、かつ同じ step に consumed の history_edge が
 *   1本以上存在する場合に Clean event とみなす。
 * - GameState 単体 (リプレイ用途) で Clean 集計したい時のため。
 */
export function detectCleanEventsFromHistory(state) {
    // step ごとに consumed / self_loop の集計
    const consumedByStep = new Map();
    const selfLoopByStep = new Map();
    for (const h of state.historyEdges.values()) {
        if (h.deletedReason === 'consumed') {
            consumedByStep.set(h.deletedAtStep, (consumedByStep.get(h.deletedAtStep) ?? 0) + 1);
        }
        else {
            selfLoopByStep.set(h.deletedAtStep, (selfLoopByStep.get(h.deletedAtStep) ?? 0) + 1);
        }
    }
    // step は 1..currentStep
    const perStep = [];
    for (let step = 1; step <= state.currentStep; step++) {
        const hasConsumed = (consumedByStep.get(step) ?? 0) > 0;
        const hasSelfLoop = (selfLoopByStep.get(step) ?? 0) > 0;
        perStep.push(hasConsumed && hasSelfLoop);
    }
    return {
        perStep,
        totalCount: perStep.filter(Boolean).length,
    };
}
export function evaluateBeauty(state, cleanLog, solverShortest) {
    const clear = state.nodes.size === 1 && state.movesUsed <= state.turnLimit;
    const clean = clear && cleanLog.totalCount > 0;
    const silent = clear && solverShortest !== null && state.movesUsed === solverShortest;
    return { clear, clean, silent };
}
//# sourceMappingURL=cleanEventDetector.js.map